export default __webpack_public_path__ + "static/media/08262021.cb5d3938.png";